import { computed } from "vue";
import { storeToRefs } from "pinia";

import { useJobsStore } from "@stores/job/jobs";
import type { FilterConfig } from "@/components/episto-ui/filter-dropdown";
import { createFilters } from "@/utils/composables/filters/createFilters";

export const useJobsFilters = () => {
  const jobsStore = useJobsStore();

  const { jobTypeFilter, mineOnlyFilter, activeFilter, jobTypeOptions } = storeToRefs(jobsStore);
  const { toggleMineOnlyFilter, clearFilters, search } = jobsStore;

  const filters = createFilters({
    filters: [
      {
        id: "jobType",
        label: "Type",
        hasSearch: true,
        options: jobTypeOptions,
        model: jobTypeFilter,
      },
      {
        id: "active",
        label: "Status",
        options: [
          { label: "Active", value: true },
          { label: "Inactive", value: false },
        ],
        model: activeFilter,
      },
    ],
    search,
    clear: clearFilters,
  });

  const filterConfigs = computed<FilterConfig[]>(() => {
    const [jobTypeConfig, activeConfig] = filters.filterConfigs.value;

    return [
      jobTypeConfig,
      {
        id: "mineOnly",
        label: "Owner",
        hasSearch: false,
        options: [{ label: "Me", value: true }],
        selectedValues: mineOnlyFilter.value ? [true] : [],
      },
      activeConfig,
    ];
  });

  const activeFiltersCount = computed(() => filters.activeFiltersCount.value + (mineOnlyFilter.value ? 1 : 0));

  const handleFilterChange = (filterId: string, value: string | number | boolean) => {
    if (filterId === "mineOnly") toggleMineOnlyFilter();
    else filters.handleFilterChange(filterId, value);
  };

  return { ...filters, filterConfigs, activeFiltersCount, handleFilterChange };
};
